import { Mobile, Desktop } from '@unified-checkout/design-system/icons/index';
import styles from './view-mode-toggle.module.scss';

export interface ViewModeToggleProps {
    previewMood: 'desktop' | 'mobile';
    onModeChange: (mode: 'desktop' | 'mobile') => void;
}

export const ViewModeToggle = ({
    previewMood,
    onModeChange,
}: ViewModeToggleProps) => {
    return (
        <div className={styles['view-mode-toggle__wrapper']}>
            <div className={styles['view-mode-toggle']}>
                <button
                    type="button"
                    className={`${styles['view-mode-toggle__button']} ${previewMood === 'mobile'
                        ? styles['view-mode-toggle__button--active']
                        : ''
                        }`}
                    onClick={() => onModeChange('mobile')}
                    aria-label="Mobile view"
                >
                    <span className={styles['view-mode-toggle__icon']}>
                        {Mobile}
                    </span>
                </button>
                <button
                    type="button"
                    className={`${styles['view-mode-toggle__button']} ${previewMood === 'desktop'
                        ? styles['view-mode-toggle__button--active']
                        : ''
                        }`}
                    onClick={() => onModeChange('desktop')}
                    aria-label="Desktop view"
                >
                    <span className={styles['view-mode-toggle__icon']}>
                        {Desktop}
                    </span>
                </button>
            </div>
        </div>
    );
};

